import { memo } from 'react'

import { ListItemIcon, Menu, MenuItem } from '@mui/material'

import { Button, useDialogState, usePopoverState } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'

import {
  getContentForms,
  getHasExportFormCsvPermission,
  getIsExportFormToPdfOptionVisible,
  getIsFormExportInProgress,
} from '@tabeeb/modules/forms/selectors'
import { getIsExportCustomFormCsvEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { exportFormToCsv, exportFormToCustomCsv, exportFormToPdf } from '@tabeeb/modules/forms/actions'

import {
  AssignmentOutlined,
  ContentPasteGo,
  IosShareOutlined,
  KeyboardArrowDown,
  PictureAsPdf,
} from '@mui/icons-material'

import { ExportFormsToCsvOptions } from '../../enums'

import ExportAsCsvDialog from '../ExportAsCsvDialog'

const ExportFormButton: React.FC = () => {
  const dispatch = useDispatch()

  const [anchorRef, open, onOpen, onClose] = usePopoverState<HTMLButtonElement>()
  const [exportAsCsvDialogOpen, onOpenExportAsCsvDialog, onCloseExportAsCsvDialog] = useDialogState()

  const contentForms = useSelector(getContentForms)
  const isFormExportInProgress = useSelector(getIsFormExportInProgress)
  const isExportToPdfOptionVisible = useSelector(getIsExportFormToPdfOptionVisible)
  const isExportCustomFormCsvButtonVisible = useSelector(getIsExportCustomFormCsvEnabled)
  const hasExportFormCsvPermission = useSelector(getHasExportFormCsvPermission)

  const handleExportToCsv = (option: ExportFormsToCsvOptions = ExportFormsToCsvOptions.All) => {
    dispatch(exportFormToCsv({ option }))
  }

  const isVisible = hasExportFormCsvPermission && contentForms.length > 0
  if (!isVisible) {
    return null
  }

  return (
    <>
      <Button
        ref={anchorRef}
        startIcon={<IosShareOutlined />}
        endIcon={<KeyboardArrowDown />}
        loading={isFormExportInProgress}
        color='primary'
        size='small'
        variant='text'
        onClick={onOpen}
      >
        Export
      </Button>

      <Menu
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={onClose}
        onClick={onClose}
      >
        {isExportCustomFormCsvButtonVisible && (
          <MenuItem
            onClick={() => {
              dispatch(exportFormToCustomCsv())
              onClose()
            }}
          >
            <ListItemIcon>
              <AssignmentOutlined />
            </ListItemIcon>
            As Custom CSV
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            if (contentForms.length <= 1) {
              handleExportToCsv(ExportFormsToCsvOptions.All)
            } else {
              onOpenExportAsCsvDialog()
            }

            onClose()
          }}
        >
          <ListItemIcon>
            <ContentPasteGo />
          </ListItemIcon>
          As CSV file
        </MenuItem>

        {isExportToPdfOptionVisible && (
          <MenuItem
            onClick={() => {
              dispatch(exportFormToPdf())
              onClose()
            }}
          >
            <ListItemIcon>
              <PictureAsPdf />
            </ListItemIcon>
            To Gallery
          </MenuItem>
        )}
      </Menu>

      <ExportAsCsvDialog open={exportAsCsvDialogOpen} onClose={onCloseExportAsCsvDialog} onSubmit={handleExportToCsv} />
    </>
  )
}

export default memo(ExportFormButton)

